<template>
  <div id="event_Calendar">
    <div v-if="!isStaff" class="mt-3 container" :class="checkMobileStatus ? 'mobile-event-container' : ''">
      <div>
        <div class="container admin-wrap">
          <div class="row header mb-3">
            <div class="col-lg-5" v-if="!checkMobileStatus">
              <h3 class="text-left">{{ lang('Event Overview') }}</h3>
              <div v-if="userSchoolInfoSerialize.length > 0" style="text-align: left">
                <a v-for="schItem in userSchoolInfoSerialize" target="_blank" style="color: red" :href="schItem.SCH_OnLineLearningSites">
                  {{ schItem.SCH_OnLineLearningSites }}
                </a>
              </div>
            </div>
            <div class="col-lg-7">
              <div class="event_viewby">
                <span class="event_viewby-title">{{ lang('Switch View') }}</span>
                <el-switch v-model="showLatest" :active-text="lang('List')" :inactive-text="lang('Calendar')" @change="showUpComing()"> </el-switch>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12" v-if="showLatest">
              <div class="event-calendar_header">
                <div class="ec-header-left">
                  <span class="render-range">{{ lang('Upcoming Events') }}</span>
                </div>
                <div class="ec-header-middle"></div>
                <div class="ec-header-right"></div>
              </div>
              <div class="latestEventList">
                <data-tables :data="upComingEventList">
                  <el-table-column v-for="item in eventListTable" min-width="50px" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom">
                  </el-table-column>
                </data-tables>
              </div>
            </div>
            <div class="col-sm-12" v-if="!showLatest">
              <div class="event-calendar">
                <div>
                  <div class="event-calendar_header">
                    <div class="ec-header-left">
                      <span class="render-range">{{ dateRange }}</span>
                    </div>
                    <!--                                        <div class="ec-header-middle">-->
                    <!--                                        </div>-->
                    <div class="ec-header-right">
                      <span @click="onClickNavi($event)">
                        <el-button class="el-icon move-day" circle data-action="move-prev">
                          <i class="fa fa-angle-left" aria-hidden="true" data-action="move-prev"></i>
                        </el-button>
                        <el-button class="el-icon move-day" circle data-action="move-next">
                          <i class="fa fa-angle-right" aria-hidden="true" data-action="move-next"></i>
                        </el-button>
                        <el-button type="primary" class="move-today" round data-action="move-today">
                          <span data-action="move-today">{{ lang('Today') }}</span>
                        </el-button>
                      </span>

                      <div class="end-result-button">
                        <el-button type="primary" style="border-radius: 24px" @click="showEndResultModal()">Postback</el-button>
                      </div>
                    </div>
                  </div>

                  <calendar
                    style="height: 800px"
                    ref="tuiCalAll"
                    :useDetailPopup="false"
                    :useCreationPopup="false"
                    :view="!checkMobileStatus ? selectedView : 'day'"
                    :calendars="calendarList"
                    :schedules="scheduleList"
                    :template="template"
                    :taskView="false"
                    :scheduleView="true"
                    :month="month"
                    :week="week"
                    :timezones="timezones"
                    :disableDblClick="true"
                    :isReadOnly="true"
                    @beforeCreateSchedule="beforeCreateSchedule"
                    @clickSchedule="onClickSchedule"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-modal
          id="create_event_modal_nonStaff"
          size="xl"
          :title="lang('Join') + lang('Event')"
          ref="EventShowModalNonStaff"
          hide-footer
          ok-variant="secondary"
        >
          <Event_Parent
            :propJoinEventDetails="joinEventDetails"
            :propEventAllParticipant="EventAllParticipant"
            :propEventID="selectedEventID"
            :eventRdEventType="rdEventType"
            :propArrobj_SelectedFiles="arrobj_SelectedFiles"
            @hideNonStaffEventModal="hideNonStaffEventModal"
            :paramServerCurrentDatetime="serverCurrentDatetime"
          />
        </b-modal>

        <b-modal
          id="create_end_result_modal"
          size="xl"
          title="Create"
          centered
          ok-title="Submit"
          @hidden="hideEndResultModal"
          @ok="createEndResult"
          :cancel-title="lang('Cancel')"
          @cancel="hideEndResultModal"
          ref="parentShowEndResultModal"
        >
          <div class="end-result-content-container">
            <div class="selected-event">
              <el-select v-model="ddlEndResultEventID" placeholder="Please select event name" style="margin-bottom: 20px" class="w-100">
                <el-option
                  v-for="eventItem in eventList"
                  class="ddlEndResultEventOption"
                  :key="eventItem.EventID"
                  :label="eventItem.EventTitle + ' (' + convertDatetimeFormat(eventItem.EventStartTime) + ')'"
                  :value="eventItem.EventID"
                >
                </el-option>
              </el-select>
            </div>

            <div class="end-result-remark">
              <label>Remarks</label>
              <el-input v-model="endResultRemarks" type="textarea" :rows="6" maxlength="3000" placeholder="Please input remarks"> </el-input>
            </div>

            <div class="end-result-files">
              <input type="file" @change="onFileChanged" multiple class="inputfile" id="FU_Portfolio" />
              <label for="FU_Portfolio">{{ lang('Select File(s)') }}</label>

              <div
                v-if="arrobj_EndResultSelectedFiles && arrobj_EndResultSelectedFiles.length > 0"
                v-for="(obj_Images, key) of arrobj_EndResultSelectedFiles"
                :key="(obj_Images, key).id"
                style="position: relative"
              >
                <label>
                  <span v-if="obj_Images.name">{{ obj_Images.name }}</span>
                  <span v-if="obj_Images.EventFIleName">{{ obj_Images.EventFIleName }}</span>
                  <span class="each-file-close" @click="cancelFiles(obj_Images, key)"><span style="vertical-align: text-bottom">x</span></span>
                </label>
              </div>
            </div>
          </div>

          <!--                    <div class="end-result-footer-container">-->
          <!--                        -->
          <!--                    </div>-->
        </b-modal>
      </div>
    </div>
    <div v-if="isStaff" class="">
      <div>
        <b-modal
          id="create_event_modal"
          size="xl"
          :title="/*lblNewEditCalendar +*/ lang('Add') + lang('Event')"
          ref="EventShowModal"
          hide-footer
          ok-variant="secondary"
        >
          <Event_Modal_Component
            :isDisable="isDisabled"
            :lblNewEditEvent="lblNewEditCalendar"
            @LoadEventDetails="LoadEventDetails"
            @hideEventShowModal="hideEventShowModal"
            @refreshBModalValue="refreshBModalValue"
            @deleteEvent="deleteEvent"
            @eventNewEdit="eventNewEdit"
            @showClassModal="showClassModal"
            :eventCheckedUser="checkedUser"
            :eventStudentInt="studentInt"
            :eventInputEventTitle="inputEventTitle"
            :eventInputEventTime="inputEventTime"
            :eventOptParentSignUp="optParentSignUp"
            :eventRdEventType="rdEventType"
            :eventInputEventRegLimit="inputEventRegLimit"
            :eventInputEventRegCutOffDay="inputEventRegCutOffDay"
            :eventInputEventRegistrationStartTime="inputEventRegistrationStartTime"
            :eventInputEventLocation="inputEventLocation"
            :eventGuestInt="guestInt"
            :eventDurationHour="EventDurationHour"
            :eventID="selectedEventID"
            :eventFiles="arrobj_SelectedFiles"
            :eventPtcPar="arrobj_ptcParticipant"
            :hangoutEventLink="hangoutEventLink"
            :googleCalendarEventID="googleCalendarEventID"
            :paramEventCreatedBy="eventCreatedBy"
            :paramTeacherIds="assTeacherIds"
            :paramPierTeachersIds="pierTeachersIds"
            :paramClassTeacherIds="classTeacherIds"
            :paramEventCreatedOn="eventCreatedOn"
            :paramEventCreatorName="eventCreatorName"
            :paramEventRemark="eventRemark"
            :paramServerCurrentDatetime="serverCurrentDatetime"
          />
        </b-modal>
        <b-modal id="addClassModal" hide-footer size="lg" :title="lang('Add') + lang('Student')" ref="addClassModal">
          <EventTagsComponent @tags="setTags" :parent_Post="post"></EventTagsComponent>
          <button class="btn btn-primary" v-on:click="AddComponentValue()">{{ lang('Add') }}{{ lang('Student') }}</button>
          <!--                    <el-button v-on:click="AddComponentValue()">Add Class</el-button>-->
        </b-modal>

        <b-modal id="copyEventModal" size="lg" :title="lang('Copy Event')" ref="copyEventModal" hide-footer>
          <div class="selected-event">
            <select
              v-model="eventCopyEventID"
              placeholder="Please select event name"
              style="margin-bottom: 20px; background: #f7f7f7; padding: 0px"
              class="w-100 form-control"
              @change="changeSelectedEvent()"
            >
              <option
                v-for="eventItem in eventList"
                class="ddlEndResultEventOption"
                :key="eventItem.EventID"
                :label="eventItem.EventTitle + ' (' + convertDatetimeFormat(eventItem.EventStartTime) + ')'"
                :value="eventItem.EventID"
                style="max-width: 100%"
              ></option>
            </select>
          </div>

          <div class="select-datetime" style="margin-bottom: 15px" v-if="copyEventDateList.length < 3">
            <div class="event-start-datetime">
              <small>{{ lang('Select Start Datetime') }}</small>
              <!--                {{inputEventTime}}-->
              <datetime
                input-id="start-datetime"
                input-class="start-datetime"
                type="datetime"
                :min-datetime="evtMinDate"
                format="dd/MM/yyyy HH:mm"
                v-model="evtStartDatetime"
              >
              </datetime>
            </div>

            <div class="event-end-datetime">
              <small>{{ lang('Select End Datetime') }}</small>

              <datetime
                input-id="end-datetime"
                input-class="end-datetime"
                type="datetime"
                :min-datetime="evtStartDatetime"
                format="dd/MM/yyyy HH:mm"
                v-model="evtEndDatetime"
              >
              </datetime>
            </div>

            <div class="add-multiple-datetime-button" style="margin-top: 10px">
              <button class="btn btn-primary" @click="addCopyDatetime()">{{ lang('Add') }}</button>
            </div>
          </div>

          <div class="added-copy-datetime-list" v-if="!isNull(copyEventDateList)" style="margin-bottom: 10px">
            <small style="color: red">* Only allow 3 datetime</small>
            <div v-for="(dateList, lIndex) in copyEventDateList" style="margin-bottom: 10px">
              <label style="display: inline-block !important; margin: 0 10px 0 0; vertical-align: middle">
                <span>{{ lIndex + 1 }} ) </span> {{ convertDatetimeFormat(dateList.copyStart) }} - {{ convertDatetimeFormat(dateList.copyEnd) }}
              </label>
              <button class="btn btn-danger" @click="removeCopyDate(dateList)">{{ lang('Remove') }}</button>
            </div>
          </div>

          <div style="text-align: right">
            <button class="btn btn-primary" @click="copyEvent()">{{ lang('Confirm') }}</button>
          </div>
        </b-modal>

        <div class="container admin-wrap mt-5">
          <div class="row header mb-3">
            <div class="col-lg-5">
              <h3 class="text-left">{{ lang('Event Overview') }}</h3>
              <a target="_blank" style="float: left; color: red" href="https://drive.google.com/file/d/1wc7Q72MX5lUZwl45NZCVXTBsP0gYzsYo/view?usp=sharing">
                {{ lang('Click here to watch the tutorial') }}
              </a>
            </div>
            <div class="col-lg-7">
              <div class="event_viewby">
                <span class="event_viewby-title">{{ lang('Switch View') }}</span>
                <el-switch v-model="showLatest" :active-text="lang('List')" :inactive-text="lang('Calendar')" @change="showUpComing()"> </el-switch>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12" v-if="showLatest">
              <div class="event-calendar_header">
                <div class="ec-header-left">
                  <span class="render-range">{{ lang('Upcoming Events') }}</span>
                </div>
                <div class="ec-header-middle"></div>
                <div class="ec-header-right">
                  <el-button type="primary" class="btnCreateEvent" round v-on:click="eventNewEdit('New')" v-if="checkedUser !== 'Parent'">
                    {{ lang('Add') }}{{ lang('Events') }}
                  </el-button>

                  <div class="end-result-button" style="margin-left: 5px" v-if="!isNull(eventList)">
                    <el-button type="primary" style="border-radius: 24px" @click="viewPostbackPage()">View Postback</el-button>
                  </div>

                  <div class="copy-event-button" style="margin-left: 5px" v-if="!isNull(eventList)">
                    <el-button type="primary" style="border-radius: 24px" @click="showCopyEventModal()">{{ lang('Copy Event') }}</el-button>
                  </div>
                </div>
              </div>
              <div class="latestEventList">
                <data-tables :data="upComingEventList" :action-col="eventListAction">
                  <el-table-column v-for="item in eventListTable" min-width="50px" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom">
                  </el-table-column>
                </data-tables>
              </div>
            </div>

            <div class="col-sm-12" v-if="!showLatest">
              <div class="event-calendar">
                <div>
                  <div class="event-calendar_header">
                    <div class="ec-header-left">
                      <el-select v-model="selectedView">
                        <el-option v-for="(options, index) in viewModeOptions" :key="index" :label="options.title" :value="options.value"> </el-option>
                      </el-select>
                    </div>
                    <div class="ec-header-middle">
                      <span class="render-range">{{ dateRange }}</span>
                    </div>
                    <div class="ec-header-right">
                      <span @click="onClickNavi($event)">
                        <el-button class="el-icon move-day" circle data-action="move-prev">
                          <i class="fa fa-angle-left" aria-hidden="true" data-action="move-prev"></i>
                        </el-button>
                        <el-button class="el-icon move-day" circle data-action="move-next">
                          <i class="fa fa-angle-right" aria-hidden="true" data-action="move-next"></i>
                        </el-button>
                        <el-button type="primary" class="move-today" round data-action="move-today">
                          <span data-action="move-today">{{ lang('Today') }}</span>
                        </el-button>
                      </span>
                      <el-button type="primary" class="btnCreateEvent" round v-on:click="eventNewEdit('NewfromButton')" v-if="checkedUser !== 'Parent'">
                        {{ lang('Add') }}{{ lang('Events') }}
                      </el-button>
                    </div>

                    <!--                                        <div class="end-result-button" style="margin-left: 5px;">-->
                    <!--                                            <el-button type="primary" style="border-radius: 24px;"-->
                    <!--                                                       @click="viewPostbackPage()">View Postback</el-button>-->
                    <!--                                        </div>-->
                  </div>

                  <div style="text-align: right" v-if="!isNull(eventList)">
                    <div class="end-result-button" style="display: inline-block; margin-right: 5px">
                      <el-button type="primary" style="border-radius: 24px" @click="viewPostbackPage()">View Postback</el-button>
                    </div>

                    <div class="copy-event-button" style="display: inline-block">
                      <el-button type="primary" style="border-radius: 24px" @click="showCopyEventModal()">{{ lang('Copy Event') }}</el-button>
                    </div>
                  </div>

                  <b-tabs class="eventPageBTabs">
                    <b-tab class="tab-my-posts" title="My Events" @click="changeEventsStatus('Self')">
                      <calendar
                        style="height: 800px"
                        ref="tuiCalSelf"
                        :useDetailPopup="false"
                        :useCreationPopup="false"
                        :view="selectedView"
                        :calendars="calendarList"
                        :schedules="scheduleList"
                        :template="template"
                        :taskView="false"
                        :scheduleView="true"
                        :theme="theme"
                        :month="month"
                        :week="week"
                        :timezones="timezones"
                        :disableDblClick="true"
                        :isReadOnly="false"
                        @beforeCreateSchedule="beforeCreateSchedule"
                        @clickSchedule="onClickSchedule"
                      />
                    </b-tab>

                    <b-tab class="tab-all-posts" title="All Events" @click="changeEventsStatus('All')">
                      <calendar
                        style="height: 800px"
                        ref="tuiCalAll"
                        :useDetailPopup="false"
                        :useCreationPopup="false"
                        :view="selectedView"
                        :calendars="calendarList"
                        :schedules="scheduleList"
                        :template="template"
                        :taskView="false"
                        :scheduleView="true"
                        :theme="theme"
                        :month="month"
                        :week="week"
                        :timezones="timezones"
                        :disableDblClick="true"
                        :isReadOnly="false"
                        @beforeCreateSchedule="beforeCreateSchedule"
                        @clickSchedule="onClickSchedule"
                      />
                    </b-tab>
                  </b-tabs>

                  <!--                                    <calendar style="height: 800px"-->
                  <!--                                              ref="tuiCal"-->
                  <!--                                              :useDetailPopup="false"-->
                  <!--                                              :useCreationPopup="false"-->
                  <!--                                              :view="selectedView"-->
                  <!--                                              :calendars="calendarList"-->
                  <!--                                              :schedules="scheduleList"-->
                  <!--                                              :template="template"-->
                  <!--                                              :taskView="true"-->
                  <!--                                              :scheduleView="true"-->
                  <!--                                              :theme="theme"-->
                  <!--                                              :month="month"-->
                  <!--                                              :week="week"-->
                  <!--                                              :timezones="timezones"-->
                  <!--                                              :disableDblClick="true"-->
                  <!--                                              :isReadOnly="false"-->
                  <!--                                              @beforeCreateSchedule="beforeCreateSchedule"-->
                  <!--                                              @clickSchedule="onClickSchedule"-->
                  <!--                                    />-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataSource from '../data/datasource'
import EventTagsComponent from '../components/Event_Tags_Component'
import Event_Modal_Component from '../components/Event/Event_Modal_Component'
import Event_Parent from '../components/Event/Event_ParentModal_Component'
import Cookies from 'js-cookie'
import { fullCalendar } from 'vue-fullcalendar'
import 'tui-calendar/dist/tui-calendar.css'
import { Calendar } from '@toast-ui/vue-calendar'
import moment from 'moment'
import { lang } from '../locale/index'
import $ from 'jquery'
import Vue from 'vue'
import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

Vue.use(Datetime)

// import Event_Modal_Component from "../components/testCreateEventModalComponent";

const today = new Date()
const getDate = (type, start, value, operator) => {
  start = new Date(start)
  type = type.charAt(0).toUpperCase() + type.slice(1)
  if (operator === '+') {
    start[`set${type}`](start[`get${type}`]() + value)
  } else {
    start[`set${type}`](start[`get${type}`]() - value)
  }
  return start
}

export default {
  name: 'Event',
  components: {
    EventTagsComponent,
    calendar: Calendar,
    Event_Modal_Component,
    Event_Parent,
    datetime: Datetime,
  },
  props: ['images', 'post'],
  async created() {
    this.getServerCurrentDatetime()

    if (Cookies.get('userTypeSession') === 'Parent') {
      this.isStaff = false
      // await this.LoadEventDetails();
      await this.LoadUpComingEvent()
      await this.loadWhitelist()
    } else {
      this.isStaff = true
      // await this.LoadProfileImg();
      // await this.LoadEventDetails();
      await this.LoadUpComingEvent()
      // await this.BindParticipantList();
      await this.getLevelSpecificSchool()
    }

    if (Cookies.get('userTypeSession') === 'Parent') {
      if (!this.isNull(Cookies.get('userSchoolInfoSerializeSession')) && Cookies.get('userSchoolInfoSerializeSession') !== 'Nill - Nill') {
        this.userSchoolInfoSerialize = Cookies.get('userSchoolInfoSerializeSession')
        this.userSchoolInfoSerialize = JSON.parse(this.userSchoolInfoSerialize)
        this.userSchoolInfoSerialize = this.userSchoolInfoSerialize.Table
      }
    }

    // UserSchoolInfoSerialize_Session
    window.addEventListener('resize', this.isMobile)
  },
  async mounted() {
    this.userType = Cookies.get('userTypeSession')
    this.sessionID = Cookies.get('userIDSession')
    this.schID = Cookies.get('schoolSession')
    if (Cookies.get('userTypeSession') === 'Parent') {
      this.eventDisplayMode = 'All'
    }
    this.init()
    this.checkUser()

    this.isMobile()

    // if (this.userType === 'Parent') {
    //     let self = this;
    //     $("#FU_Portfolio").on("change", function (e) {
    //         console.log("hihi");
    //         self.onFileChanged(e);
    //     });
    // }
  },
  data() {
    return {
      //Start: class component
      spdSelection: [],
      tags: [],
      guestInt: [],
      EventAllParticipant: [],
      studentInt: [],
      inputVisible: false,
      inputValue: '',
      guestList: [
        {
          prop: 'value',
          label: lang('Guest') + lang('Email'),
        },
        {
          prop: 'Type',
          label: lang('Guest') + lang('Type'),
        },
      ],
      eventListAction: {
        label: lang('Edit'),
        props: {
          align: 'right',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.editEvent(row)
            },
            label: '',
          },
        ],
      },
      guestListAction: {
        label: lang('Delete'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-delete',
            },
            handler: row => {
              this.guestInt.splice(this.guestInt.indexOf(row), 1)
            },
            label: lang('Delete'),
          },
        ],
      },
      userType: '',
      isStaff: '',
      imgStaffProfile: '',
      //
      obj_SelectedComponent: '',
      str_PostComponentTitle: '',
      arrobj_SelectedItem: [],
      obj_ComponentProperties: {},
      //
      upComingDetailClicked: false,
      isDisabled: false,
      datePicker: {
        disabledDate(date) {
          return date < new Date().getTime() - 1 * 24 * 60 * 60 * 1000
        },
      },
      ddlParticipant: '',
      selectedParticipantList: [],
      rdEventType: '',
      rdEventTypeList: [
        {
          value: 'Event',
          label: 'Event',
        },
        {
          value: 'SchoolClosure',
          label: 'School Closure',
        },
        {
          value: 'PublicHoliday',
          label: 'Public Holiday',
        },
      ],
      eventList: [],
      latestEventList: [],
      levelList: [],
      inputEventTime: [],
      inputEventRegistrationStartTime: '',
      EventDurationHour: '',
      optParentSignUp: false,
      inputEventRegCutOffDay: 0,
      inputEventRegLimit: 0,
      inputEventTitle: '',
      inputEventLocation: '',
      inputEventParticipant: '',
      inputEventParticipantList: [],
      inputEventDesc: '',
      selectedEventID: '',
      ddlClassLevel: '',
      //Full Calendar
      mode: 'single',
      selectedDate: null,
      sessionID: '',
      lblNewEditCalendar: '',
      MasterParticipantList: [],
      CurrentParticipantList: [],
      ParticipantNameListIntTemp: [],
      ParticipantNameListInt: [],
      tempParticipantList: [],
      ParticipantNameListAction: {
        label: lang('Delete'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.ParticipantNameListInt.splice(this.ParticipantNameListInt.indexOf(row), 1)
              this.selectedParticipantList.splice(this.selectedParticipantList.indexOf(row), 1)
              let objValue = {
                CONname: row.StAllItem,
                CONEmail: row.SelectedConEmail,
                CONid: row.SelectedConID,
                EventParID: row.SelectedEventParID,
              }
              this.CurrentParticipantList.push(objValue)
            },
            label: lang('Delete'),
          },
        ],
      },
      ParticipantNameList: [
        {
          prop: 'StAllItem',
          label: lang('Email Address'),
        },
      ],
      showLatest: false,

      //calendar option
      viewModeOptions: [
        {
          title: lang('Monthly'),
          value: 'month',
        },
        {
          title: lang('Weekly'),
          value: 'week',
        },
        {
          title: lang('Daily'),
          value: 'day',
        },
      ],
      dateRange: '',
      selectedView: 'month',
      calendarList: [
        {
          id: 'PublicHoliday',
          name: 'Public Holiday',
          bgColor: '#9e5fff',
          borderColor: '#9e5fff',
        },
        {
          id: 'Event',
          name: 'Event',
          bgColor: '#00a9ff',
          borderColor: '#00a9ff',
        },
        {
          id: 'SchoolClosure',
          name: 'SchoolClosure',
          bgColor: '#ffc900',
          borderColor: '#ffc900',
        },
        {
          id: 'PTC',
          name: 'PTC',
          bgColor: '#69d5a1',
          borderColor: '#69d5a1',
        },
      ],
      scheduleList: [],
      timezones: [
        {
          timezoneOffset: 480,
          displayLabel: 'GMT+08:00',
          tooltip: 'Singapore',
        },
        {
          timezoneOffset: -420,
          displayLabel: 'GMT-08:00',
          tooltip: 'Los Angeles',
        },
      ],
      template: {
        milestone(schedule) {
          return `<span style="color:#fff;background-color: ${schedule.bgColor};">${schedule.title}</span>`
        },
        milestoneTitle() {
          return 'Milestone'
        },
        allday(schedule) {
          return `${schedule.title}`
        },
        alldayTitle() {
          return 'All Day'
        },
        popupSave() {
          return 'Saves'
        },
        popupDetailBody(schedule) {
          return schedule.body
        },
      },
      month: {
        startDayOfWeek: 0,
      },
      week: {
        showTimezoneCollapseButton: true,
        timezonesCollapsed: true,
      },
      checkedUser: '',
      isEditEvent: false,
      editEventID: '',
      theme: {
        'month.dayname.height': '42px',
      },
      joinEventDetails: [],
      arrobj_SelectedFiles: [],

      eventListTable: [
        {
          prop: 'CONname',
          label: lang('Created by'),
        },
        {
          prop: 'EventTitle',
          label: lang('Event') + lang('Title'),
        },
        {
          prop: 'EventType',
          label: lang('Event') + lang('Type'),
        },
        {
          prop: 'EventStartTime_DateTimeConvert',
          label: lang('Event Start Date'),
        },
        {
          prop: 'EventEndTime_DateTimeConvert',
          label: lang('Event End Date'),
        },
      ],

      checkMobileStatus: false,

      arrobj_ptcParticipant: [],
      upComingEventList: [],

      hangoutEventLink: '',
      googleCalendarEventID: '',

      ddlEndResultEventID: '',
      endResultRemarks: '',
      arr_EndResultSelectedFileList: [],
      arrobj_EndResultSelectedFiles: [],
      isUploadFile: false,
      userSchoolInfoSerialize: [],
      eventCreatedBy: '',
      eventDisplayMode: 'Self',
      assTeacherIds: '',
      pierTeachersIds: '',
      classTeacherIds: '',
      eventCreatedOn: '',
      eventCreatorName: '',
      eventRemark: '',

      eventListDateFrom: '',
      eventListDateTo: '',
      eventCopyEventID: '',
      evtStartDatetime: '',
      evtEndDatetime: '',
      evtMinDate: '',
      copyEventDateList: [],
      copyEventFiles: [],
      copyEventData: [],
      copyStartDatetime: '',
      copyEndDatetime: '',
      createdGoogleCalendarEventLink: '',
      createdGoogleCalendarID: '',
      schID: '',
      serverCurrentDatetime: '',
    }
  },
  watch: {
    selectedView(newValue) {
      if (this.eventDisplayMode === 'Self') {
        this.$refs.tuiCalSelf.invoke('changeView', newValue, true)
      } else {
        this.$refs.tuiCalAll.invoke('changeView', newValue, true)
      }
      // this.$refs.tuiCal.invoke('changeView', newValue, true);
      this.setRenderRangeText()
    },
  },
  methods: {
    lang,
    sleep(milliseconds) {
      return new Promise(resolve => setTimeout(resolve, milliseconds))
    },
    hideEventShowModal() {
      this.$refs['EventShowModal'].hide()
      // this.$refs['EventShowModalNonStaff'].hide();
    },
    hideNonStaffEventModal() {
      this.$refs['EventShowModalNonStaff'].hide()
    },
    setTags(value) {
      try {
        this.tags = value
      } catch (e) {
        this.results = e
      }
    },
    AddComponentValue() {
      try {
        if (this.tags) {
          // this.$notify({
          //     title: 'Success',
          //     message: 'Successfully!',
          //     type: 'success'
          // });
          this.$refs.addClassModal.hide()
          let uniqueTags = []
          this.tags.forEach(object => {
            const isExist = this.studentInt.find(m => m.value === object.Student_ID)
            if (!isExist) {
              uniqueTags.push(object)
            }
          })
          uniqueTags.forEach(m => {
            let my_object = {
              Type: 'Student',
              value: m.Student_ID,
              label: m.First_Name + ' ' + m.Middle_Name + ' ' + m.Last_Name,
            }
            this.studentInt.push(my_object)
          })
        } else {
          this.$notify.error({
            title: lang('Error, please try again'),
            message: lang('Error'),
          })
        }
      } catch (e) {
        this.results = e
      }
    },
    showLoading() {
      this.$vs.loading()
    },
    hideLoading() {
      this.$vs.loading.close()
    },
    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0 || obj === ''
    },
    showMore(obj) {
      this.upComingDetailClicked = true
      this.LoadUpComingEventDetail(obj)
    },
    async BindEventFields(resultTable) {
      try {
        this.ParticipantNameListIntTemp = []
        this.ParticipantNameListInt = []
        this.CurrentParticipantList = []

        // resultTable.forEach(async m => {
        resultTable.forEach(m => {
          this.inputEventTitle = m.EventTitle
          this.rdEventType = m.EventType
          // this.inputEventTime[0] = new Date(m.EventStartTime);
          // this.inputEventTime[1] = new Date(m.EventEndTime);
          this.inputEventTime[0] = moment(m.EventStartTime).format('DD/MM/YYYY HH:mm:ss')
          this.inputEventTime[1] = moment(m.EventEndTime).format('DD/MM/YYYY HH:mm:ss')
          this.inputEventRegLimit = m.EventRegLimit
          this.inputEventRegCutOffDay = m.EventRegCutOffDay
          this.inputEventLocation = m.EventLocation
          if (m.EventRegistrationStartTime !== undefined) {
            this.inputEventRegistrationStartTime = new Date(m.EventRegistrationStartTime)
          }
          this.EventDurationHour = m.EventDuration

          this.hangoutEventLink = m.EventLink
          this.googleCalendarEventID = m.EventCalendarID

          this.eventCreatedBy = m.EventCreatedBy
          if (m.teachers) {
            this.assTeacherIds = m.teachers
          }
          if (m.pierteachers) {
            this.pierTeachersIds = m.pierteachers
          }
          if (m.classTeacher) {
            this.classTeacherIds = m.classTeacher
          }
          this.eventCreatedOn = moment(m.EventCreatedOn).format('DD MMM YYYY HH:mm:ss')
          this.eventCreatorName = m.CONname
          this.eventRemark = m.EventRemarks

          // const resp = await DataSource.shared.getEventParticipantByEventID(m.EventID);
          // console.log(resp);
          DataSource.shared.getEventParticipantByEventID(m.EventID).then(result => {
            // console.log(result);
            if (result.code === '2') {
              this.MasterParticipantList.forEach(m => {
                this.CurrentParticipantList.push(m)
              })
              this.guestInt = []
              this.studentInt = []
            } else {
              const participantResponse = result.Table
              this.EventAllParticipant = result.Table
              let editParticipantTemp = []

              this.arrobj_ptcParticipant = participantResponse

              if (participantResponse !== undefined) {
                participantResponse.forEach(m => {
                  let my_object = {
                    Type: m.EventParType,
                    value: m.PaxName,
                  }
                  editParticipantTemp.push(my_object)
                })
              }

              this.ParticipantNameListInt = editParticipantTemp
              this.guestInt = this.ParticipantNameListInt.filter(d => {
                return d.Type === 'Others'
              })

              let studentIntFilter = []
              if (participantResponse !== undefined) {
                studentIntFilter = participantResponse.filter(d => {
                  return d.EventParType === 'Student'
                })
              }

              if (this.isStaff === false) {
                this.studentInt = studentIntFilter
              } else {
                let tempStudentInt = []
                studentIntFilter.forEach(m => {
                  let my_object = {
                    Type: m.EventParType,
                    value: m.EventParPaxID,
                    label: m.PaxName,
                  }
                  tempStudentInt.push(my_object)
                })
                this.studentInt = tempStudentInt
              }
            }
          })
          // if (resp) {
          //     if (resp.code === '2') {
          //         this.MasterParticipantList.forEach(m => {
          //             this.CurrentParticipantList.push(m);
          //         });
          //         this.guestInt = [];
          //         this.studentInt = [];
          //     } else {
          //         const participantResponse = resp.Table;
          //         this.EventAllParticipant = resp.Table;
          //         let editParticipantTemp = [];
          //         participantResponse.forEach(m => {
          //             let my_object = {
          //                 Type: m.EventParType,
          //                 value: m.PaxName,
          //             };
          //             editParticipantTemp.push(my_object);
          //         });
          //         this.ParticipantNameListInt = editParticipantTemp;
          //         this.guestInt = this.ParticipantNameListInt.filter(d => {
          //             return d.Type === "Others";
          //         });
          //         let studentIntFilter = participantResponse.filter(d => {
          //             return d.EventParType === "Student";
          //         });
          //         if (this.isStaff === false) {
          //             this.studentInt = studentIntFilter;
          //         } else {
          //             let tempStudentInt = [];
          //             studentIntFilter.forEach(m => {
          //                 let my_object = {
          //                     Type: m.EventParType,
          //                     value: m.EventParPaxID,
          //                     label: m.PaxName
          //                 };
          //                 tempStudentInt.push(my_object);
          //             });
          //             this.studentInt = tempStudentInt;
          //         }
          //
          //
          //     }
          // }
          if (m.EventParentSignUp === 'Yes') {
            this.optParentSignUp = true
          }
        })
      } catch (e) {
        this.results = e
      }
    },
    async editEvent(objValue) {
      try {
        this.$vs.loading()
        //capture EventID
        let obj = {
          eventID: objValue.EventID,
          eventCreatedBy: objValue.EventCreatedBy,
        }

        this.selectedEventID = obj.eventID
        const response = await DataSource.shared.getEventDetails(this.selectedEventID)
        this.refreshBModalValue(response)
        this.BindEventFields(response.Table)
        await this.sleep(800)
        let promise_GetPostFile = await DataSource.shared.getEventFile(this.selectedEventID)

        this.arrobj_SelectedFiles = promise_GetPostFile

        if (response.code === '88') {
          window.location.replace('/')
        } else if (response.code === '99') {
          console.log('Cannot get event')
        } else if (response.code === '2') {
          console.log('invalid ID')
          window.location.replace('/')
        }

        if (this.isStaff === false) {
          this.joinEventDetails = response.Table[0]
          let joinStatus = this.EventAllParticipant.find(d => d.eligibleRegistrationAction === 'Join')
          this.$refs['EventShowModalNonStaff'].show()
        } else if (this.isDisabled === true) {
          this.$refs['EventShowModal'].show()
        } else {
          this.isEditEvent = true
          this.editEventID = objValue.EventID
          this.$refs['EventShowModal'].show()
        }
        this.eventNewEdit('Edit')
        this.$vs.loading.close()
      } catch (e) {
        console.log(e)
      }
    },
    async deleteEvent(eventID /*, isSend*/) {
      try {
        //capture EventID
        this.selectedEventID = eventID

        if (eventID === undefined) {
          eventID = this.editEventID
        }
        const response = await DataSource.shared.deleteEvent(eventID /*, isSend*/)

        if (response.code === '88') {
          window.location.replace('/')
        } else if (response.code === '99') {
          console.log('Event Not Found')
        } else if (response.code === '2') {
          console.log('invalid ID')
          window.location.replace('/')
        } else if (response.code === '1') {
          // alert('Event Deleted!');
          this.$notify({
            title: lang('Success'),
            message: lang('Event Removed'),
            type: 'success',
          })
          // window.location.replace('/event');
          this.LoadEventDetails()
          this.$refs['EventShowModal'].hide()
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getLevelSpecificSchool() {
      try {
        const response = await DataSource.shared.getLevelSpecificSchool(Cookies.get('schoolSession'))
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.levelList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async LoadEventDetails() {
      this.$vs.loading()
      try {
        if (Cookies.get('userTypeSession') === 'Parent') {
          this.eventDisplayMode = 'All'
        }

        this.scheduleList = []
        // this.calendarList = [];
        // const response = DataSource.shared.getEvent();
        const response = DataSource.shared.getEvent(this.eventListDateFrom, this.eventListDateTo)

        response.then(response => {
          this.$vs.loading.close()

          // console.log(response, "resp");

          if (response.code === '88') {
            window.location.replace('/')
          }

          if (response && response.Table.length < 1) {
            alert('No record found')
            console.log('No record found')
          } else if (response.code === '99') {
            alert('No event found')
            console.log('No event found')
          } else {
            this.eventList = response.Table ? response.Table : []
            if (this.userType === 'Teacher') {
              this.eventList = this.eventList.filter(a => {
                return a.EventType === 'PTC' || a.EventType === 'Elearning'
              })
            }

            // pierteachers, classTeacher
            if (this.eventDisplayMode === 'Self') {
              this.eventList = this.eventList.filter((eList, eIndex) => {
                let arrTeacherIds = []
                if (eList.teachers) {
                  arrTeacherIds = eList.teachers.split(',')
                }

                let arrPierteacherIds = []
                if (eList.pierteachers) {
                  arrPierteacherIds = eList.pierteachers.split(',')
                }

                let arrClassTeacherIds = []
                if (eList.classTeacher) {
                  arrClassTeacherIds = eList.classTeacher.split(',')
                }

                return (
                  eList.EventCreatedBy === Cookies.get('userIDSession') ||
                  arrTeacherIds.includes(Cookies.get('userIDSession')) ||
                  arrPierteacherIds.includes(Cookies.get('userIDSession')) ||
                  arrClassTeacherIds.includes(Cookies.get('userIDSession'))
                )
              })
            }

            let arrCreatedBy = []
            this.eventList.forEach(m => {
              let mycolor = '#' + ((Math.random() * 0xffffff) << 0).toString(16)

              // if (!arrCreatedBy.includes(m.EventCreatedBy)) {
              //     let objCalendar = {
              //         id: m.EventCreatedBy,
              //         name: m.CONname,
              //         bgColor: mycolor,
              //         borderColor: mycolor
              //     };
              //
              //     this.calendarList.push(objCalendar);
              //     arrCreatedBy.push(m.EventCreatedBy);
              // }

              // m.start = m.EventCreatedOn_Convert;
              let objects = {
                id: m.EventID,
                calendarId: m.EventType,
                // calendarId: m.EventCreatedBy,
                title: m.EventTitle,
                category: 'time',
                dueDateClass: '',
                start: new Date(m.EventStartTime.replace(/\s/, 'T')),
                end: new Date(m.EventEndTime.replace(/\s/, 'T')),
                showContentButton: true,
                showConnectionButton: true,
                showObservationButton: true,
                location: m.EventLocation,
                body:
                  'Registration Time: ' +
                  m.EventRegistrationStartTime_Convert +
                  '\n' +
                  'Registration Limit: ' +
                  m.EventRegLimit +
                  '\n' +
                  'Registration cutoff(days): ' +
                  m.EventRegCutOffDay,
                raw: m.EventCreatedBy,
              }

              this.scheduleList.push(objects)
            })

            // if (this.eventDisplayMode === "Self") {
            //     this.scheduleList = this.scheduleList.filter((d, dIndex) => {
            //         return d.raw === this.sessionID;
            //     });
            // }
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    async LoadUpComingEvent() {
      try {
        this.upComingEventList = []

        const response = await DataSource.shared.getUpComingEvent()
        if (response.Table) {
          if (response.code === '2') {
            console.log('No record found')
          } else if (response.code === '99') {
            console.log('99')
          } else {
            // this.upComingEventList = response.Table;
            this.upComingEventList = response.Table ? response.Table : []
          }
        }
        // response.then((response) => {
        //
        //     if (response.code === '2') {
        //         console.log('No record found');
        //     } else if (response.code === '99') {
        //         console.log('99');
        //     } else {
        //         this.upComingEventList = (response.Table) ? response.Table : [];
        //     }
        // });
      } catch (e) {
        console.log(e)
      }
    },
    async LoadUpComingEventDetail(value) {
      try {
        var obj = {
          EventStartTime: value,
        }

        const response = await DataSource.shared.getUpComingEventDetail(JSON.stringify(obj))

        if (response.code === '99') {
          console.log('99')
        } else if (response.code === '2') {
          console.log('2')
          alert('No record found')
        } else {
          return (this.upComingEventDetailList = response.Table ? response.Table : [])
        }
      } catch (e) {
        console.log(e)
      }
    },
    eventNewEdit(value, res) {
      $('.tui-full-calendar-month-guide-block').remove() // changes
      if (value === 'New') {
        this.lblNewEditCalendar = value
        this.refreshBModalValue(res)
        const updateRes = String(res.getFullYear()) + '-' + String(res.getMonth() + 1) + '-' + String(res.getDate())
        let todayDate = new Date()
        let updateDate = String(todayDate.getFullYear()) + '-' + String(todayDate.getMonth() + 1) + '-' + String(todayDate.getDate())
        let isBefore = moment(updateDate).isSameOrBefore(updateRes, 'day')

        if (this.isStaff === false) {
          // this.$refs.EventShowModalNonStaff.show();
        } else if (isBefore === true) {
          this.$refs.EventShowModal.show()
        } else {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Please choose another date'),
          })
        }
      } else if (value === 'NewfromButton') {
        this.lblNewEditCalendar = 'New'
        this.refreshBModalValue(res)

        if (this.isStaff === false) {
          // this.$refs.EventShowModalNonStaff.show();
        } else {
          this.$refs.EventShowModal.show()
        }
      } else {
        this.lblNewEditCalendar = value

        if (this.isStaff === false) {
          // this.$refs.EventShowModalNonStaff.show();
        } else {
          this.$refs.EventShowModal.show()
        }
      }

      if (this.isStaff === false) {
        // this.$refs.EventShowModalNonStaff.show();
      } else {
        // changes
        if (moment(new Date(res)).format('YYYY/MM/DD') >= moment().format('YYYY/MM/DD')) {
          this.$refs.EventShowModal.show()
        }

        // this.$refs.EventShowModal.show();
      }

      // if (this.isStaff === false) {
      //     // this.$refs.EventShowModalNonStaff.show();
      // } else {
      //     this.$refs.EventShowModal.show();
      // }
    },
    refreshBModalValue(res) {
      // let getCurrentDateTime = new Date();
      this.isDisabled = false
      this.inputEventTitle = ''
      this.rdEventType = ''
      this.inputEventTime[0] = new Date(res)
      this.inputEventTime[1] = new Date(res)
      this.inputEventRegLimit = 0
      this.inputEventRegCutOffDay = 0
      this.inputEventLocation = ''
      this.optParentSignUp = false
      this.ParticipantNameListInt = []
      this.ddlParticipant = ''
      this.CurrentParticipantList = []
      this.guestInt = []
      this.studentInt = []
      this.inputEventRegistrationStartTime = ''
      this.MasterParticipantList.forEach(m => {
        this.CurrentParticipantList.push(m)
      })
      this.EventDurationHour = ''
      this.arrobj_SelectedFiles = []

      this.hangoutEventLink = ''
      this.googleCalendarEventID = ''
      this.eventRemark = ''
    },
    showClassModal() {
      this.$refs.addClassModal.show()
    },
    validEmail() {
      const re = /(.+)@(.+){2,}\.(.+){2,}/
      return re.test(this.inputEventParticipant.toLowerCase())
    },
    removeParticipantList(guest) {
      // this.inputEventParticipantList.splice(this.inputEventParticipantList.indexOf(guest), 1);
      this.guestInt.splice(this.guestInt.indexOf(guest), 1)
    },
    async btnJoinEvent() {
      console.log('btnJoinEvent')
    },
    async btnRejectEvent() {
      console.log('btnRejectEvent')
    },

    //calendar
    init() {
      this.setRenderRangeText()
      this.checkRouterID()
      this.getMonthDay()
    },
    checkRouterID() {
      if (this.$route.query.id) {
        let feedEventID = this.$route.query.id
        let item = {
          EventID: feedEventID,
          EventCreatedBy: '',
        }
        this.editEvent(item)
      }
    },
    setRenderRangeText() {
      const { invoke } = this.eventDisplayMode === 'Self' ? this.$refs.tuiCalSelf : this.$refs.tuiCalAll

      // const {invoke} = this.$refs.tuiCal;
      const view = invoke('getViewName')
      const calDate = invoke('getDate')
      const rangeStart = invoke('getDateRangeStart')
      const rangeEnd = invoke('getDateRangeEnd')
      let year = calDate.getFullYear()
      let month = calDate.getMonth() + 1
      let date = calDate.getDate()
      let dateRangeText = ''
      let endMonth, endDate, start, end
      switch (view) {
        case 'month':
          dateRangeText = `${year}-${month}`
          break
        case 'week':
          year = rangeStart.getFullYear()
          month = rangeStart.getMonth() + 1
          date = rangeStart.getDate()
          endMonth = rangeEnd.getMonth() + 1
          endDate = rangeEnd.getDate()
          start = `${year}-${month}-${date}`
          end = `${endMonth}-${endDate}`
          // dateRangeText = `${start} ~ ${end}`;
          dateRangeText = `${year}-${month}` // changes
          break
        default:
          dateRangeText = `${year} ${month} ${date}`
      }

      if (view === 'day') {
        this.dateRange = moment(dateRangeText, 'YYYY MM DD').format('YYYY MMMM ')
      } else {
        this.dateRange = moment(dateRangeText, 'YYYY-MM').format('YYYY MMMM ')
      }
      // this.dateRange = moment(dateRangeText).format('YYYY MMMM ');
    },
    onClickNavi(event) {
      const { target } = event
      let action = target.dataset ? target.dataset.action : target.getAttribute('data-action')
      if (action) {
        action = action.replace('move-', '')
        if (this.eventDisplayMode === 'Self') {
          this.$refs.tuiCalSelf.invoke(action)
        } else {
          this.$refs.tuiCalAll.invoke(action)
        }
        // this.$refs.tuiCal.invoke(action);
        this.setRenderRangeText()

        this.getMonthDay()
      }
    },
    beforeCreateSchedule(res) {
      this.inputEventTime[0] = new Date(res.start)
      this.inputEventTime[1] = new Date(res.start)
      this.eventNewEdit('New', res.start)
    },
    onClickSchedule(res) {
      let item = {
        EventID: res.schedule.id,
        EventCreatedBy: res.schedule.raw,
      }
      this.editEvent(item)
    },
    //check user
    checkUser() {
      this.checkedUser = Cookies.get('userTypeSession')
    },

    isMobile() {
      let screenWidth = window.innerWidth
      if (screenWidth <= 770) {
        this.checkMobileStatus = true
        // return true;
      } else {
        this.checkMobileStatus = false
        // return false;
      }
    },

    showUpComing() {
      if (this.showLatest) {
        this.LoadUpComingEvent()
      }
    },

    convertDatetimeFormat(datetimeVal) {
      return moment(datetimeVal).format('DD/MM/YYYY HH:mm')
      // return moment(datetimeVal).format("DD/MM/YYYY HH:mm:ss");
    },

    // for parent
    showEndResultModal() {
      this.$refs['parentShowEndResultModal'].show()
    },

    hideEndResultModal() {
      this.$refs['parentShowEndResultModal'].hide()

      this.clearEndResult()
    },

    onFileChanged(event) {
      // this.$vs.loading();

      this.arr_EndResultSelectedFileList = []

      this.isUploadFile = true
      for (let file of event.target.files) {
        let fileSize = file.size / 1024 / 1024
        if (fileSize > 10) {
          this.$notify.error({
            title: lang('Error'),
            message: lang('File limit exceeded 10MB'),
          })
        } else {
          if (this.isWhitelist(file)) {
            // this.arrobj_SelectedFiles = event.target.files;
            this.arr_EndResultSelectedFileList = event.target.files
          } else {
            this.$notify.error({
              title: lang('Error'),
              message: lang('File Format Not Accepted'),
            })
          }
        }
      }

      if (this.arr_EndResultSelectedFileList && this.arr_EndResultSelectedFileList.length > 0) {
        // this.$vs.loading.close();
        this.changeSelectedFilesFormat()
      }
    },

    async loadWhitelist() {
      await DataSource.shared.getWhitelist().then(result => {
        this.arrstr_Whitelist = result.Table
      })
    },

    isWhitelist(file) {
      let temparrstr = file.name.split('.')
      let str_Ext = ('.' + temparrstr[temparrstr.length - 1]).toUpperCase()
      let isWhitelisted = this.arrstr_Whitelist.findIndex(x => x.ext.toUpperCase() === str_Ext) !== -1
      let isValidFile = file.size > 0

      return isWhitelisted && isValidFile
    },

    changeSelectedFilesFormat() {
      for (let a = 0; a < this.arr_EndResultSelectedFileList.length; a++) {
        this.arrobj_EndResultSelectedFiles.push(this.arr_EndResultSelectedFileList[a])
      }
      this.convertSelectedFilesToFileFormat()
    },

    convertSelectedFilesToFileFormat() {
      this.convertedFileForInsert = []
      this.arrobj_EndResultSelectedFiles.forEach(images => {
        if (images.name === undefined) {
          let url = 'data:' + images.EventFileType + ';base64,' + images.EventFileOriginal
          let fileName = images.EventFIleName
          let mimeType = images.EventFileType
          this.urltoFile(url, fileName, mimeType)
            .then(file => {
              this.convertedFileForInsert.push(file)
            })
            .finally(() => {
              this.getImagePreviews()
            })
        } else {
          this.convertedFileForInsert.push(images)
        }
      })
    },

    getImagePreviews() {
      /*
                  Iterate over all of the files and generate an image preview for each one.
                */
      for (let i = 0; i < this.arrobj_EndResultSelectedFiles.length; i++) {
        /*
                      Ensure the file is an image file
                    */
        if (/\.(jpe?g|png|gif)$/i.test(this.arrobj_EndResultSelectedFiles[i].name)) {
          /*
                          Create a new FileReader object
                        */
          let reader = new FileReader()

          /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */
          reader.addEventListener(
            'load',
            function () {
              if (this.$refs['image' + parseInt(i)]) {
                this.$refs['image' + parseInt(i)][0].src = reader.result
              }
            }.bind(this),
            false,
          )

          /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
          reader.readAsDataURL(this.arrobj_EndResultSelectedFiles[i])
        }
      }
    },

    cancelFiles(obj, objKey) {
      let fileName = obj.EventFIleName ? obj.EventFIleName : obj.name

      this.arrobj_EndResultSelectedFiles = this.arrobj_EndResultSelectedFiles.filter((d, dIndex) => {
        let eachName = d.EventFIleName ? d.EventFIleName : d.name
        let isValid = true
        if (objKey === dIndex && eachName === fileName) {
          isValid = false
        }

        return isValid
      })

      this.convertSelectedFilesToFileFormat()
    },

    clearEndResult() {
      this.ddlEndResultEventID = ''
      this.endResultRemarks = ''
      this.arr_EndResultSelectedFileList = []
      this.arrobj_EndResultSelectedFiles = []

      $('#FU_Portfolio').val('')
    },

    async createEndResult() {
      if (this.ddlEndResultEventID === '') {
        this.$notify.error({
          title: lang('Error'),
          message: lang('Please select event'),
        })

        return
      }

      // if () {
      //
      // }
      // if (this.arrobj_EndResultSelectedFiles.length === 0) {
      //     this.$notify.error({
      //         title: lang('Error'),
      //         message: lang('Please upload files'),
      //     });
      // }

      this.$vs.loading()

      try {
        let response = await DataSource.shared.saveEndResult(this.arrobj_EndResultSelectedFiles, this.ddlEndResultEventID, this.endResultRemarks)

        if (response) {
          if (response.code === '88') {
            console.log('88')
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('99')
          } else if (response.code === '1') {
            this.$notify({
              title: lang('Success'),
              message: 'Successfully Added Postback!',
              type: 'success',
            })
          }

          this.$vs.loading.close()
        }
      } catch (e) {
        console.log(e)
      }
    },
    // for Parent

    // for Staff
    async changeEventsStatus(displayMode) {
      this.eventDisplayMode = displayMode
      this.isStaff = true
      await this.LoadEventDetails()
      await this.LoadUpComingEvent()
      await this.getLevelSpecificSchool()
    },

    viewPostbackPage() {
      this.$router.push({
        name: 'EventPostBack',
        params: {
          paramEventList: this.eventList,
        },
      })
    },

    getMonthDay() {
      const { invoke } = this.eventDisplayMode === 'Self' ? this.$refs.tuiCalSelf : this.$refs.tuiCalAll
      // const {invoke} = this.$refs.tuiCal;
      const calDate = invoke('getDate')
      let year = calDate.getFullYear()
      let month = calDate.getMonth() + 1
      let date = calDate.getDate()

      let startOfMonth = ''
      let endOfMonth = ''
      let fullDate = date + '/' + month + '/' + year
      fullDate = moment(fullDate, 'DD/M/YYYY').format('DD/MM/YYYY')

      startOfMonth = moment(fullDate, 'DD/MM/YYYY').startOf('month').format('DD/MM/YYYY')
      endOfMonth = moment(fullDate, 'DD/MM/YYYY').endOf('month').format('DD/MM/YYYY')

      this.eventListDateFrom = startOfMonth
      this.eventListDateTo = endOfMonth

      // console.log(this.eventListDateFrom, "from", this.eventListDateTo , "To");
      this.LoadEventDetails()
    },

    showCopyEventModal() {
      this.evtMinDate = moment().toISOString()
      this.clearCopyEvent()

      this.$refs['copyEventModal'].show()
    },

    hideCopyEventModal() {
      this.$refs['copyEventModal'].hide()
    },

    async changeSelectedEvent() {
      const response = await DataSource.shared.getEventDetails(this.eventCopyEventID)
      this.refreshBModalValue(response)
      this.BindEventFields(response.Table)
      await this.sleep(800)
      let promise_GetPostFile = await DataSource.shared.getEventFile(this.eventCopyEventID)

      // this.copyEventFiles = promise_GetPostFile;

      this.copyEventFiles = []
      if (promise_GetPostFile.Table && promise_GetPostFile.Table.length > 0) {
        for (let image of promise_GetPostFile.Table) {
          let url = 'data:' + image.EventFileType + ';base64,' + image.EventFileOriginal
          let fileName = image.EventFIleName
          let mimeType = image.EventFileType
          this.urltoFile(url, fileName, mimeType).then(file => {
            this.copyEventFiles.push(file)
          })
        }
      }

      if (response.code === '88') {
        window.location.replace('/')
      } else if (response.code === '99') {
        console.log('Cannot get event')
      } else if (response.code === '2') {
        console.log('invalid ID')
        window.location.replace('/')
      }

      this.copyEventData = response.Table[0]

      // console.log(this.copyEventFiles, this.copyEventData, "chekingasdas");
    },

    addCopyDatetime() {
      if (this.evtStartDatetime !== '' && this.evtEndDatetime !== '') {
        let obj = {}
        obj.copyStart = this.evtStartDatetime
        obj.copyEnd = this.evtEndDatetime
        this.copyEventDateList.push(obj)

        this.evtStartDatetime = ''
        this.evtEndDatetime = ''
      }
    },

    removeCopyDate(selectedDatetime) {
      this.copyEventDateList.splice(this.copyEventDateList.indexOf(selectedDatetime), 1)
    },

    async copyEvent() {
      try {
        if (this.eventCopyEventID === '') {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Please select event!'),
          })
        } else if (this.isNull(this.copyEventDateList)) {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Please select start and end datetime!'),
          })
        } else {
          this.$vs.loading()

          this.copyEventDateList.forEach((object, index) => {
            this.copyStartDatetime = moment(object.copyStart).format('DD/MM/YYYY HH:mm:ss')
            this.copyEndDatetime = moment(object.copyEnd).format('DD/MM/YYYY HH:mm:ss')

            let Obj = {
              EventTitle: this.copyEventData.EventTitle,
              EventType: this.copyEventData.EventType,
              EventStartTime: this.copyStartDatetime,
              EventEndTime: this.copyEndDatetime,
              EventRegistrationStartTime: '',
              // EventRegistrationStartTime: this.inputEventRegistrationStartTime,
              EventParentSignUp: this.copyEventData.EventParentSignUp,
              EventRegCutOffDay: this.copyEventData.EventRegCutOffDay,
              EventRegLimit: this.copyEventData.EventRegLimit,
              EventLocation: '',
              EventDuration: '',

              EventLink: '',
              EventCalendarID: '',
              EventRemarks: this.copyEventData.EventRemarks ? this.copyEventData.EventRemarks : '',
            }

            let guestIntSave = []
            guestIntSave.push(...this.guestInt)
            if (this.studentInt) {
              this.studentInt.forEach(item => {
                let participantListDetail = {
                  Type: 'Student',
                  value: item.value,
                }
                guestIntSave.push(participantListDetail)
              })
            }

            if (this.schID === 'SCH201400000480' || this.schID === 'SCH201400000510') {
              let randomRequestID = Math.random().toString(36).substring(2, 15)
              Obj.EventLink = 'https://meet.google.com/lookup/' + randomRequestID
              Obj.EventCalendarID = randomRequestID
              let response = {}
              try {
                response = DataSource.shared.saveEvent(this.copyEventFiles, JSON.stringify(Obj), JSON.stringify(guestIntSave))
              } catch (e) {
                console.log(e)
              }

              response
                .then(savedValue => {
                  if (savedValue.code === '88') {
                    console.log('88')
                    window.location.replace('/')
                  } else if (savedValue.code === '99') {
                    console.log('99')
                  } else if (savedValue.code === '1') {
                    this.$notify({
                      title: lang('Success'),
                      message: lang('Event Added'),
                      type: 'success',
                    })
                  }

                  // this.$vs.loading.close();
                })
                .finally(() => {
                  if (index + 1 === this.copyEventDateList.length) {
                    this.LoadEventDetails()
                    this.$vs.loading.close()
                  }
                })
            } else {
              this.newGoogleCalendarEvent()
                .then(resp => {
                  if (resp) {
                    Obj.EventLink = this.createdGoogleCalendarEventLink
                    Obj.EventCalendarID = this.createdGoogleCalendarID
                    let response = {}
                    try {
                      response = DataSource.shared.saveEvent(this.copyEventFiles, JSON.stringify(Obj), JSON.stringify(guestIntSave))
                    } catch (e) {
                      console.log(e)
                    }

                    response.then(savedValue => {
                      if (savedValue.code === '88') {
                        console.log('88')
                        window.location.replace('/')
                      } else if (savedValue.code === '99') {
                        console.log('99')
                      } else if (savedValue.code === '1') {
                        this.$notify({
                          title: lang('Success'),
                          message: lang('Event Added'),
                          type: 'success',
                        })

                        // if ( (index+1) === this.copyEventDateList.length && savedValue.code ) {
                        //     this.LoadEventDetails();
                        // }
                        // this.LoadEventDetails();
                      }

                      // this.$vs.loading.close();
                    })
                  } else {
                    this.$notify.error({
                      title: lang('Error'),
                      message: lang('Integration problems!'),
                    })
                  }
                })
                .finally(() => {
                  if (index + 1 === this.copyEventDateList.length) {
                    this.LoadEventDetails()
                    this.$vs.loading.close()
                  }
                })
            }
          })

          this.hideCopyEventModal()
        }
      } catch (e) {
        console.log(e, 'copy error msg!')
      }
    },

    clearCopyEvent() {
      this.eventCopyEventID = ''
      this.evtStartDatetime = ''
      this.evtEndDatetime = ''
      this.copyEventDateList = []
    },

    async newGoogleCalendarEvent() {
      let creatorEmail = Cookies.get('userEmailSession')
      let randomRequestID = this.copyEventData.EventType === 'Elearning' ? Math.random().toString(36).substring(2, 15) : ''
      let calendarStartDatetime = moment(this.copyStartDatetime, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
      let calendarEndDatetime = moment(this.copyEndDatetime, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
      let generateType = this.copyEventData.EventType === 'Event' ? 'normal' : this.copyEventData.EventType === 'Elearning' ? 'normalWithLink' : ''

      let googleCalendarResp = await DataSource.shared.createGoogleCalendarEvent(
        creatorEmail,
        this.copyEventData.EventTitle,
        '',
        '',
        calendarStartDatetime,
        calendarEndDatetime,
        randomRequestID,
        '',
        generateType,
      )

      if (googleCalendarResp) {
        this.createdGoogleCalendarID = googleCalendarResp.id
        this.createdGoogleCalendarEventLink = googleCalendarResp.hangoutLink
      }

      return googleCalendarResp
    },

    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer()
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType })
        })
    },

    async getServerCurrentDatetime() {
      await DataSource.shared.getServerCurrentDatetime().then(result => {
        this.serverCurrentDatetime = result
      })
    },
  },
  destroyed() {
    window.removeEventListener('resize', this.isMobile)
  },
}
</script>
<style scoped>
.each-file-close {
  padding: 0 5px;
  border-radius: 50%;
  border: 1px solid #ccc;
  cursor: pointer;
  margin-left: 10px;
}

.el-date-editor {
  width: 100% !important;
}

.buttonArea {
  margin: 20px 0 0 0;
}

.requiredFieldsMsg {
  color: red;
  font-weight: bold;
}

.btn-primary {
  display: inline;
}

.buttonArea .btn-primary {
  margin: 0 0 0 20px;
}

.actionDiv {
  text-align: right;
}

.EligibleColor {
  color: green !important;
}

.NotEligibleColor {
  color: red !important;
}

.textArea {
  width: 100%;
  resize: none;
}

/* Mobile Css */
.mobile-event-container {
  padding: unset !important;
  margin: unset !important;
}

.mobile-event-container .admin-wrap {
  padding: unset;
  margin: unset;
  width: 100%;
}

.mobile-event-container .move-today {
  width: auto;
}

.mobile-event-container .ec-header-left {
  width: unset;
  float: left;
}

.mobile-event-container .ec-header-right {
  width: unset;
  float: right;
}
</style>

<style>
.eventPageBTabs .nav-tabs .nav-link.active {
  background-color: #dee2e6;
  border-color: #dee2e6 #dee2e6;
}
</style>
